import { useBrandingContext } from '@group-link-one/gl-components';
import { useFallBackTranslate } from './hooks/useFallBackTranslate';

export const useFallBackTemplate = () => {
  const { customLocale } = useFallBackTranslate();
  const { isDarkMode } = useBrandingContext();

  return {
    customLocale,
    isDarkMode,
  };
};
